import React from 'react'
import { Button } from 'react-bootstrap'

const VipSuccess = ({
  pubId,
  userId,
  siteConfigId
}: {
  pubId: number,
  userId: string,
  siteConfigId: number
}) => {
  const adminLink = `https://admin.submittable.com/Publisher/Details/${pubId}`
  return (
    <div>
      <h1 style={{ color: 'green' }}>Success!</h1>
      <p>Publisher: <a href={adminLink}>{adminLink}</a></p>
      { userId !== '00000000-0000-0000-0000-000000000000' ? <p>User ID: {userId}</p> : ''}
      <p>Site Config ID: {siteConfigId}</p>
      <Button onClick={() => window.location.reload()}>Return to form</Button>
    </div>
  )
}

export default VipSuccess



// WEBPACK FOOTER //
// ./src/components/VipSuccess.js